import { FormattedMessage } from '@alltrails/shared/react-intl';
import Typography from 'components/Typography';
import TermsOfService from 'components/TermsOfService';
import EmailPasswordLogin from 'components/EmailPasswordLogin';
import Link from '@alltrails/shared/denali/components/Link';
import AltLoginsForm from 'components/AltLoginsForm';
import { facebookHandler, appleHandler, googleHandler } from 'utils/OAuthHandlers';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import { useDispatch } from 'react-redux';
import LoginResponse from 'types/LoginResponse';
import { GoogleLoginResponse } from 'react-google-login';
import * as styles from './LogIn.module.scss';
import { setUser } from '../../userSlice';
import { setFormAuthenticityToken } from '../../formAuthenticityTokenSlice';

// Desktop: https://app.zeplin.io/project/6218dc5177101a641929be50/screen/6218e13d32440b60dea65769
// Mobile: https://app.zeplin.io/project/6218dc5177101a641929be50/screen/6218dec5dccf0d54f6dee4f4

type Props = {
  onSuccess: () => void;
  redirectUrl?: string;
};

export default function LogIn({ onSuccess, redirectUrl }: Props) {
  const dispatch = useDispatch();
  const languageRegionCode = useLanguageRegionCode();

  function handleSuccess({ form_authenticity_token, user }: LoginResponse) {
    if (redirectUrl) {
      window.location.assign(redirectUrl);
    } else {
      dispatch(setFormAuthenticityToken(form_authenticity_token));
      dispatch(setUser(user));
      onSuccess();
      global.google?.accounts.id.cancel(); // google can be undefined on mobile web
    }
  }

  async function handleGoogle(response: GoogleLoginResponse) {
    handleSuccess(await googleHandler(response));
  }

  function handleFacebook(response: any) {
    facebookHandler(
      response,
      languageRegionCode,
      handleSuccess,
      () => null,
      () => null
    );
  }

  return (
    <div className={styles.content}>
      <Typography component="div" variant="heading400" mb="24">
        <FormattedMessage defaultMessage="Welcome back." />
        <br />
        <FormattedMessage defaultMessage="Log in and start exploring." />
      </Typography>
      <div className={styles.grid}>
        <EmailPasswordLogin handleLoginSuccess={handleSuccess} />
        <Typography component="div" variant="paragraph200">
          <Link href="/users/password/new">
            <FormattedMessage defaultMessage="Forgot your password?" />
          </Link>
        </Typography>
        <AltLoginsForm googleLoginHandler={handleGoogle} facebookLoginHandler={handleFacebook} appleLoginHandler={() => appleHandler()} />
        <TermsOfService />
      </div>
    </div>
  );
}
